import React, { useContext } from "react";
import { Alert, Button, Spin } from "antd";
import FormSearch from "./FormSearch";
import FormFrequency from "./FormFrequency";
import GuideToolbar from "./GuideToolbar";
import ChartContainer from "./ChartContainer";
import SpectrumContext, { SpectrumProvider } from "./SpectrumContext";
import FormBox from "./FormBox";

import "./SpectrumDashboard.scss";

function SpectrumDashboard() {
  const {
    inputsState,
    onClickShowChart,
    isLoadingStats,
    usageList,
    statsByAlmBusNmAndDistrictLv1,
  } = useContext(SpectrumContext);

  return (
    <div
      style={{
        maxWidth: 1200,
        margin: "0 auto",
      }}
    >
      <FormBox>
        <GuideToolbar />
        <FormFrequency />
        <FormSearch />
      </FormBox>

      <Button
        onClick={onClickShowChart}
        type={"primary"}
        style={{ width: "300px", margin: "2em auto", display: "block"}}
        disabled={
          isLoadingStats ||
          inputsState.sidoCheckList.length === 0 ||
          inputsState.ucodeCheckList.length === 0 ||
          inputsState.usageCheckList.length === 0
        }
      >
        {isLoadingStats && <Spin spinning={true} style={{ marginRight: 8 }} />}
        무선국 통계 검색
      </Button>

      <div style={{ marginBottom: "2em" }}>
        {isLoadingStats && (
          <Alert
            message={"데이터를 불러오고 있습니다. 잠시만 기다려 주세요."}
            banner
          />
        )}

        {usageList.length === 0 && (
          <Alert
            message={
              "주파수범위를 입력하시고 설정버튼을 클릭 후, 용도를 선택해주세요."
            }
            banner
          />
        )}

        {usageList.length > 0 && inputsState.usageCheckList.length === 0 && (
          <Alert message={"용도를 선택해주세요."} banner />
        )}

        {usageList.length > 0 &&
          inputsState.usageCheckList.length > 0 &&
          Object.keys(statsByAlmBusNmAndDistrictLv1).length === 0 &&
          !isLoadingStats && (
            <Alert message={"조회된 데이터가 없습니다."} banner />
          )}
      </div>

      <ChartContainer />
    </div>
  );
}

export default function SpectrumDashboardWrapper(props) {
  return (
    <SpectrumProvider>
      <SpectrumDashboard {...props} />
    </SpectrumProvider>
  );
}
